/** `?add=1` opens a page's create dialog, so the dialog survives a refresh. */

import { useSearchParams } from "react-router";

export function useAddParam(): [boolean, (on: boolean) => void] {
  const [params, setParams] = useSearchParams();
  const set = (on: boolean) =>
    setParams((p) => {
      if (on) p.set("add", "1");
      else p.delete("add");
      return p;
    });
  return [params.get("add") === "1", set];
}
